import {Pagination, Table, Input} from "antd";
import {useEffect, useState} from "react";
import service from "../api/FetchInterceptor";

const DataTable = ({
                       url,
                       columns,
                       perPage = 25,
                       pagination = true,
                       refreshTrigger = 0,
                       params = null,
                       search = true
                   }) => {
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const [loading, setLoading] = useState(false)

    const loadData = (q = null) => {
        setLoading(true)

        service({
            method: 'GET',
            url,
            params: {
                ...params,
                page,
                per_page: perPage,
                q
            }
        }).then((response) => {
            if (pagination && response.data) {
                setData(response.data)
                setPage(response.current_page)
                setTotal(response.total)
            } else {
                setData(response)
                setTotal(response.length || 0)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        loadData()
    }, [page, perPage, refreshTrigger, params]);

    const handlePageChange = (newPage) => {
        setPage(newPage)
    }

    return <>
        {
            search && (
                <div className="my-4">
                    <Input.Search
                        placeholder="Rechercher..."
                        onSearch={(e) => loadData(e)}
                        style={{width: 500, marginRight: 16}}
                    />
                </div>
            )
        }


        <div className="d-flex justify-content-end">
            <h4> {total} résultat (s)</h4>
        </div>

        <Table
            loading={loading}
            className="custom-table mt-2"
            columns={columns}
            dataSource={data}
            pagination={pagination ? false : {pageSize: perPage}}
        />

        {
            pagination && (
                <Pagination
                    className="mt-4"
                    current={page}
                    total={total}
                    pageSize={perPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            )
        }
    </>

}

export default DataTable;